export default __webpack_public_path__ + "src/image/vimdrones_logo.png";